export const config = {
    appname: 'bblprivilege',
    client_id: '1913492792231145', // App ID
    facebook_app_id: '1913492792231145', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'apibbl2',
    agency_id: '',
    bzbsUrlOldSupport: 'https://api.buzzebees.com',
    bzbsUrl: 'https://apibbl2.buzzebees.com',
    bzbsModuleUrl: 'https://bblmodule.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule36.buzzebees.com',
    webShoppingCartUrl: 'https://shoppingcartservice36.buzzebees.com',
    bzbsBlobUrl: '	https://cdn.buzzebees.com/th',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyBf7p6eWQa3lDj5RKchQqZMdwkb1DnbYLQ",
        authDomain: "bbl-redemption-prd.firebaseapp.com",
        projectId: "bbl-redemption-prd",
        storageBucket: "bbl-redemption-prd.appspot.com",
        messagingSenderId: "645377180932",
        appId: "1:645377180932:web:466bcc8dac74fe35fe3c51",
        measurementId: "G-TYNPFHYS18"
    },
    gameLanding: "https://gamevue.buzzebees.com"
};
